import React, { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import { TabItem, Text } from './styles';
// нужно или добавить еще опцию с навлинками, когда будем выносить компоненет или иначе решать эту проблему

export interface TabProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  as?: 'button' | 'a';
  to?: string;
  isActive?: boolean;
  activeClassName?: string;
  text: string;
  icon: JSX.Element;
}

export function Tab(props: TabProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  const { text, icon, ...other } = props;

  return (
    <TabItem type={props.as === 'button' ? 'button' : undefined} {...other}>
      {icon}
      <Text>{text}</Text>
    </TabItem>
  );
}
